import _classCallCheck from "/Users/benn/Dropbox/Mon Mac (MacBook-Pro.local)/Documents/Work/Personal Website/personal-site/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/benn/Dropbox/Mon Mac (MacBook-Pro.local)/Documents/Work/Personal Website/personal-site/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DOMSelector
 *
 * A polyfill singleton to select DOM elements
 */

/**
 * Convert nodes list to array
 *
 * NodesList to array conversion helper
 *
 * The NodesList API is slightly different of the Array.
 * It misses for instance the .map() method which is used by this ColorMix.
 */
var convertNodesListToArray = function convertNodesListToArray(list) {
  var elements = [];
  list.forEach(function (element) {
    elements.push(element);
  });
  return elements;
};

var DOMSelector = /*#__PURE__*/function () {
  function DOMSelector() {
    _classCallCheck(this, DOMSelector);
  }

  _createClass(DOMSelector, [{
    key: "querySelectorAll",
    value: function querySelectorAll(selector) {
      var elements = [];

      if (typeof document != 'undefined') {
        selector = new String(selector);

        if (selector.length > 0) {
          if ('querySelectorAll' in document) {
            elements = convertNodesListToArray(document.querySelectorAll(selector));
          } else {
            switch (selector[0]) {
              case '#':
                elements = [document.getElementById(selector.slice(1))];
                break;

              case '.':
                if (document.getElementsByClassName) {
                  elements = convertNodesListToArray(document.getElementsByClassName(selector));
                } else {
                  var DOMelements = document.getElementsByTagName('*');
                  var i = DOMelements.length;

                  while (i--) {
                    if (DOMelements[i].className === selector.slice(1)) {
                      elements.push(DOMelements[i]);
                    }
                  }
                }

                break;

              default:
                elements = convertNodesListToArray(document.getElementsByTagName(selector));
                break;
            }
          }
        }
      }

      return elements;
    }
  }]);

  return DOMSelector;
}();

var instance = new DOMSelector();
export default instance;